import { Avatar, Box, Checkbox, Chip, Typography } from "@material-ui/core";
import LocalOfferOutlinedIcon from "@material-ui/icons/LocalOfferOutlined";
import { TeamMember } from "../../../@types/custom";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { formatLocalPhoneNumber } from "../../../services/virtualNumbers";
import { pastelChipSx } from "../../../components/__haim/VirtualNumbers/virtualNumberChips";

type AutocompleteOptionProps = {
  index: number;
  member: string;
  selectedMembers: string[];
  members: string[];
  myTeam: TeamMember[];
  isSearchActive: boolean;
  /** Virtual number → customer-defined tag naming the lead source it's used for. */
  tagsByNumber?: Record<string, string>;
};

export function AutocompleteOption(props: AutocompleteOptionProps): React.ReactElement {
  const {
    index,
    selectedMembers,
    members,
    member,
    myTeam,
    isSearchActive,
    tagsByNumber = {},
    ...rest
  } = props;
  const { t } = useTranslation();

  if (index === 0 && !isSearchActive) {
    return (
      <li {...rest}>
        <Checkbox
          checked={selectedMembers.length === members.length}
          name="toggleAll"
          indeterminate={selectedMembers.length > 0 && selectedMembers.length !== members.length}
        />
        {t("callsPage.toggleMembers")}
      </li>
    );
  }

  const [email, number] = member.split("|");
  const { ownerFullName, photoURL } = myTeam.find((t) => t.email === email) ?? {};
  const tag = tagsByNumber[number];
  return (
    <Box component="li" display="flex" {...rest}>
      <Box>
        <Avatar sx={{ width: "28px", height: "28px", mr: 1 }} alt={ownerFullName} src={photoURL} />
      </Box>
      <Box minWidth={0}>
        {/* The tag is what identifies the number for the user ("the source"), so
            it leads; the digits stay below as the unambiguous identifier. */}
        {tag && (
          <Chip
            size="small"
            icon={<LocalOfferOutlinedIcon />}
            label={tag}
            sx={{ ...pastelChipSx("tag"), maxWidth: "100%", mb: 0.25 }}
          />
        )}
        <Typography variant="subtitle2" color="grey.700">
          {ownerFullName ?? email}
        </Typography>
        <Typography variant="subtitle2" color="grey.600" sx={{ direction: "ltr", textAlign: "left" }}>
          {formatLocalPhoneNumber(number)}
        </Typography>
      </Box>
    </Box>
  );
}
